import React, {Suspense, useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import moment from 'moment'
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/pt';
import 'moment/locale/it';

import ModulePreview from '../../components/ModulePreview';
import syncFilters from 'js/components/shared/actions/syncFilters'
import drupalSettings, {filters} from '../../drupalSettings';
import {connect} from 'react-redux';
import filterChange from '../../actions/filterChange';
import filterApply from '../../actions/filterApply';
import {FILTER_DATES} from '../../constants';
import ModuleDatesForm from './components/ModuleDatesForm';
import {pushFiltersApply, pushFiltersClose} from 'js/helpers/gtm';

import styles from './SearchModuleDates.module.scss'

const cx = classnames.bind(styles);
export const wordings = drupalSettings?.bookingBlock || {};

export const getDateText = (date, locale = filters.locale) => {
  if (!date) return ''
  return moment(date).locale(locale).format('ddd, D MMM.')
}

const SearchModuleDates = function ({
  data = [],
  className,
  activeFilter,
  syncFiltersAction,
  filterChangeAction,
  filterApplyAction,
}) {
  const [fromDate, toDate] = data;
  const previewValues = useMemo(function () {
    return [{
      label: wordings.dateInPlaceholder,
      value: fromDate ? getDateText(fromDate) : undefined,
      readOnly: true,
    }, {
      label: wordings.dateOutPlaceholder,
      value: toDate ? getDateText(toDate) : undefined,
      readOnly: true,
    }]
  }, [fromDate, toDate])

  const isActive = useMemo(() => activeFilter === FILTER_DATES, [activeFilter])

  const onFormSubmit = function (data) {
    filterChangeAction(FILTER_DATES, data)
    filterApplyAction(FILTER_DATES, true)
    syncFiltersAction(true)
    pushFiltersApply('dates')
    closeModal()
  }

  const onPreviewClick = function () {
    filterChangeAction('activeFilter', FILTER_DATES)
  }

  const onFormClose = function () {
    pushFiltersClose('dates')
    closeModal()
  }

  const closeModal = () => {
    filterChangeAction('activeFilter', null)
  }

  return (
    <div className={cx('root', className)}>
      <ModulePreview
        icon="CALENDAR"
        values={previewValues}
        onClick={onPreviewClick}
      />
      {isActive && (
        <Suspense>
          <ModuleDatesForm
            data={data}
            onSubmit={onFormSubmit}
            onClose={onFormClose}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleDates.propTypes = {
  data: PropTypes.any
}

export default connect(({form}) => ({
  data: form?.searchFilters?.dates || [],
  activeFilter: form?.searchFilters?.activeFilter,
}), {
  filterChangeAction: filterChange,
  filterApplyAction: filterApply,
  syncFiltersAction: syncFilters,
})(SearchModuleDates);
